import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import codes from './modules/codes'
import campaigns from './modules/campaigns'
import dashboard from './modules/dashboard'
import elabel from './modules/elabel'
import landingPages from './modules/landing-pages'
import redirection from './modules/redirection'
import products from './modules/products'
import qr from './modules/qr'
import snackbar from './modules/snackbar'
import prefixes from './modules/prefixes'
import gallery from './modules/gallery'
import config from './modules/atp-config'
import transactions from './modules/atp-transactions'
import files from './modules/atp-files'
import atpProducts from './modules/atp-products'
import mock from './modules/atp-mock'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    codes,
    campaigns,
    products,
    qr,
    snackbar,
    prefixes,
    gallery,
    config,
    transactions,
    files,
    atpProducts,
    mock,
    dashboard,
    elabel,
    landingPages,
    redirection
  }
})
